import React from 'react';
import { FastForwardIcon } from 'lucide-react';
import { boostLiveTruck, useLiveTruck } from '../../hooks/useLiveTruck';
interface TruckBoostButtonProps {
  className?: string;
}

/** Démo : fait avancer le camion en accéléré (3 secondes) jusqu'à la maison. */
export function TruckBoostButton({
  className = ''
}: TruckBoostButtonProps) {
  const {
    arrived,
    boosting
  } = useLiveTruck();
  if (arrived) return null;
  return <button type="button" onClick={boostLiveTruck} disabled={boosting} className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/95 px-3 py-1.5 text-xs font-bold text-ville-navy shadow-md shadow-ville-navy/10 transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo disabled:cursor-default disabled:text-ville-indigo ${className}`} data-id="element-1057" data-mp="1q8k0421isaf4">
      <FastForwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1058" data-mp="ate8gjgnyia7" />
      {boosting ? 'En accéléré…' : 'Accélérer'}
    </button>;
}